export const PROJECT_STATUS = {
  INITIATE: 'initiate',
  PLANNING: 'planning',
  EXECUTION: 'execution',
  CLOSEOUT: 'closeout',
  ARCHIVED: 'archived'
};
